<template>
	<div class="event-market" :data-event-type="attributes.type">
		<p class="event-market-info">
			{{ translate(`event.${attributes.type}_event.market_cta`) }}
		</p>
		<div class="event-market-info-box">
			<Tooltip
				:placement="Placements.TOP"
				customWidth="18rem"
				:heading="translate(`event.${attributes.type}_event.eventium`)"
			>
				<template #element>
					<div class="event-market-info-box-eventium">
						<div
							class="event-market-info-box-label"
							v-html="formatNumber(eventium)"
						/>
						<AppMainIcon
							:iconName="ResourceType.EVENTIUM"
							:iconSize="20"
						/>
					</div>
				</template>

				<template #tooltip>
					<div class="event-market-info-box-tooltip">
						{{ translate("event.current_balance") }}
					</div>
				</template>
			</Tooltip>
			<Tooltip
				:placement="Placements.TOP"
				customWidth="18rem"
				:heading="translate('event.legendary_chest_key')"
			>
				<template #element>
					<div class="event-market-info-box-keys">
						<div
							class="event-market-info-box-label"
							v-html="
								formatNumber(grandPrizeState?.chestKeys ?? 0)
							"
						/>
						<AppMainIcon
							:iconName="ResourceType.CHEST_KEY"
							:iconSize="20"
						/>
					</div>
				</template>

				<template #tooltip>
					<div class="event-market-info-box-tooltip">
						{{ translate("event.chest_key_info") }}
					</div>
				</template>
			</Tooltip>
		</div>
		<EventMarketBox :type="MarketChestType.COMMON" />
		<EventMarketBox :type="MarketChestType.RARE" />
		<EventMarketBox :type="MarketChestType.LEGENDARY" />
	</div>
</template>

<script lang="ts" setup>
import { useEventStore } from "@/event";
import { ResourceType } from "@/game/entities/config/resources.ts";
import useResourcesStore from "@/store/useResourcesStore";
import { MarketChestType } from "@/types/event.ts";
import { Placements } from "@/types/ui.ts";
import { formatNumber } from "@/utils/format.ts";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import AppMainIcon from "../AppMainIcon.vue";
import Tooltip from "../Tooltip.vue";
import EventMarketBox from "./EventMarketBox.vue";

const resourcesStore = useResourcesStore();
const { eventium } = storeToRefs(resourcesStore);
const eventStore = useEventStore();
const { attributes, grandPrizeState } = storeToRefs(eventStore);
</script>

<style lang="scss" scoped>
.event-market {
	$connectorHeight: 1rem;
	width: 100%;
	@include flex-col-center;
	gap: 0.5rem;
	padding: 0.5rem 0.75rem;
	&-info {
		margin-bottom: 0.5rem;
		color: #fff3dd;
		font-size: 0.906rem;
		text-align: center;
		text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
		&-box {
			position: relative;
			gap: 0.5rem;
			z-index: 1;
			margin-bottom: 0.15rem;
			@include flex-row-center;
			&-label {
				margin-bottom: 0.25rem;
			}
			&-tooltip {
				width: 100%;
				text-align: center;
			}
			&-eventium,
			&-keys {
				@include flex-row-center;
				gap: 0.25rem;
				color: #fff3dd;
				font-weight: bold;
				font-size: 1.188rem;
				text-shadow: 0.044rem 0.044rem 0 rgba(0, 0, 0, 0.6);
			}
			&-eventium {
				width: 10rem;
				height: 2.5rem;
			}
			&-keys {
				width: 5rem;
				height: 2.5rem;
			}
		}
	}
	&[data-event-type="solarfair"] {
		.event-market-info-box-eventium {
			@include background(
				url($path-events + "solarfair/backgrounds/bg-current-eventium.avif"),
				contain,
				center,
				no-repeat
			);
		}
		.event-market-info-box-keys {
			@include background(
				url($path-events + "solarfair/backgrounds/bg-keys.avif"),
				contain,
				center,
				no-repeat
			);
		}
	}
	&[data-event-type="pirates"] {
		.event-market-info-box-eventium {
			@include background(
				url($path-events + "pirates/backgrounds/bg-current-eventium.avif"),
				contain,
				center,
				no-repeat
			);
		}
		.event-market-info-box-keys {
			@include background(
				url($path-events + "pirates/backgrounds/bg-keys.avif"),
				contain,
				center,
				no-repeat
			);
		}
	}
}
</style>
